import { colors, medias, mixins, shadows, sizes, typography } from "features/theme/variables"

export const clapAndClickFoTheme = {
  colors,
  medias,
  mixins,
  shadows,
  sizes,
  typography,
}

export type ClapAndClickFoTheme = typeof clapAndClickFoTheme
